import React from 'react'
import { Container, ContentHeader } from 'components'

import EntriesForm from './components/EntriesForm'

const EntriesNew = ({ match }) => {
  return (
    <Container>
      <ContentHeader title="Cobranças adicionais" subtitle="Nova" />
      <EntriesForm match={match}></EntriesForm>
    </Container>
  )
}

export default EntriesNew
